import React, { useEffect, useState } from "react"
import { slide as Menu } from 'react-burger-menu'
import { Link } from "gatsby"

import closeIcon from '../images/close-icon-wht.svg'
import burgerIconWhite from '../images/burger-icon-white.svg'
import logoBlack from '../images/3blackdot-logo-white.svg'

export default function Header({ isHeaderBgBlack }) {
  const [navbar, setNavbar] = useState(false)
  const changeBackground = () => {
    if (window.scrollY >= 66) {
      setNavbar(true)
    } else {
      setNavbar(false)
    }
  }
  useEffect(() => {
    changeBackground()
    window.addEventListener("scroll", changeBackground)
  })
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const handleStateChange = (state) => setIsMenuOpen(state.isOpen)
  const handleCloseMenu = () => setIsMenuOpen(false)

  return (
    <header className={navbar || isHeaderBgBlack ? "bg-black fixed w-full z-40" : "fixed w-full z-40 bg-black sm:bg-transparent"}>
        <div className="py-5 px-10 lg:px-16 text-white font-bold">
          <div className="grid grid-cols-2 lg:grid-cols-12">
            <div className="col-span-1 lg:col-span-3">
              <Link cover onClick={() => { handleCloseMenu() }} to="/" className="py-5">
                <img
                  className="w-36 lg:w-40 logo-black"
                  src={logoBlack}
                  alt="3BLACKDOT Logo"
                />
              </Link>
            </div>
            <div className="hidden lg:block lg:col-span-6"></div>
            <div className="col-span-1 lg:col-span-3 leading-none text-m">
              <Menu
                isOpen={isMenuOpen}
                onClose={handleCloseMenu}
                onStateChange={handleStateChange}
                itemListElement='div'
                customBurgerIcon={ <img src={burgerIconWhite} /> }
                customCrossIcon={ <img src={closeIcon} /> }
                right
                className="uppercase py-14 px-16 text-right"
              > 
                <Link onClick={() => { handleCloseMenu() }} to="/#ourCommunity" className="py-5 block" bg="#000000">
                  Work
                </Link>
                <Link cover onClick={() => { handleCloseMenu() }} to="/about" className="py-5 block" bg="#000000">
                  About
                </Link>
                <Link cover onClick={() => { handleCloseMenu() }} to="/publishing" className="py-5 block" bg="#000000">
                  Publishing
                </Link>
                <Link cover onClick={() => { handleCloseMenu() }} to="/careers" className="py-5 block" bg="#000000">
                  Careers
                </Link>
                <Link cover onClick={() => { handleCloseMenu() }} to="/contact" className="py-5 block" bg="#000000">
                  Contact
                </Link>
                <a onClick={() => { handleCloseMenu() }} href="https://shop.3blackdot.com/" target="_blank" rel="noopener noreferrer" className="external-link py-4 block">SHOP</a>
              </Menu>
            </div>
          </div>
        </div>
    </header>
    
  )
}
